import "./App.css";
import TroopOptimizer from "./components/TroopOptimizer";
import { LanguageProvider } from "./i18n/LanguageContext";
import { ThemeProvider } from "./i18n/ThemeContext";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <LanguageProvider>
          <TroopOptimizer />
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
